var _g, _path, _rect, _g2, _path2, _rect2, _g3, _rect3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPage3Bar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 33,
    viewBox: "0 0 369 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_1792)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15,
    fill: "#004068",
    stroke: "#004068",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.078 20.142L22.72 10.5L24.0003 11.7802L13.078 22.7025L7.99976 17.6257L9.28001 16.3455L13.078 20.142Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 15.5,
    width: 80,
    height: 2,
    fill: "#004068"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9_1792)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 16.5,
    r: 15,
    fill: "#004068",
    stroke: "#004068",
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.078 20.142L134.72 10.5L136 11.7802L125.078 22.7025L120 17.6257L121.28 16.3455L125.078 20.142Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 15.5,
    width: 80,
    height: 2,
    fill: "#004068"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_9_1792)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 16.5,
    r: 15,
    fill: "white",
    stroke: "#004068",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 16.5,
    r: 5.5,
    fill: "#EA7024"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 15.5,
    width: 80,
    height: 2,
    fill: "#969696"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_9_1792)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 352.5,
    cy: 16.5,
    r: 15,
    fill: "white",
    stroke: "#969696",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.252 21.157C347.523 21.1539 346.9 20.9615 346.383 20.5799C345.866 20.1983 345.47 19.6428 345.196 18.9134C344.922 18.1839 344.785 17.3053 344.785 16.2773C344.785 15.2525 344.922 14.3769 345.196 13.6506C345.473 12.9242 345.87 12.3703 346.387 11.9886C346.907 11.607 347.529 11.4162 348.252 11.4162C348.976 11.4162 349.596 11.6085 350.113 11.9933C350.63 12.3749 351.025 12.9289 351.299 13.6552C351.576 14.3784 351.715 15.2525 351.715 16.2773C351.715 17.3084 351.578 18.1886 351.304 18.918C351.03 19.6443 350.634 20.1998 350.117 20.5845C349.6 20.9661 348.979 21.157 348.252 21.157ZM348.252 19.9244C348.892 19.9244 349.393 19.612 349.753 18.9872C350.116 18.3625 350.297 17.4592 350.297 16.2773C350.297 15.4925 350.214 14.8293 350.048 14.2876C349.885 13.7429 349.65 13.3305 349.342 13.0504C349.037 12.7673 348.674 12.6257 348.252 12.6257C347.615 12.6257 347.115 12.9396 346.752 13.5675C346.389 14.1953 346.206 15.0986 346.203 16.2773C346.203 17.0652 346.284 17.7315 346.447 18.2763C346.613 18.8179 346.849 19.2288 347.154 19.5089C347.458 19.7859 347.824 19.9244 348.252 19.9244ZM353.154 19.1534V17.9993L357.239 11.5455H358.149V13.2443H357.572L354.65 17.87V17.9439H360.249V19.1534H353.154ZM357.636 21V18.8026L357.646 18.2763V11.5455H358.998V21H357.636Z",
    fill: "#969696"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_1792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9_1792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(112.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9_1792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(224.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_9_1792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(336.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage3Bar);
export default __webpack_public_path__ + "static/media/page3bar.826100dc01d38daa78ddecead6f6421e.svg";
export { ForwardRef as ReactComponent };